import { useCallback, useEffect, useState } from 'react';
import { deliveryMethodMissingErrMsg, t } from '../../../common/i18n';

export interface UseDeliveryValidationOptions {
  hasDeliveryAddress: boolean;
  hasDeliveryOfferings: boolean;
  hasSelectedDeliveryMethod: boolean;
}

export interface UseDeliveryValidationResult {
  addressError: string | undefined;
  deliveryMethodError: string | undefined;
  clearAddressError: () => void;
  clearDeliveryMethodError: () => void;
  validate: () => boolean;
}

export const useDeliveryValidation = ({
  hasDeliveryAddress,
  hasDeliveryOfferings,
  hasSelectedDeliveryMethod,
}: UseDeliveryValidationOptions): UseDeliveryValidationResult => {
  const [addressError, setAddressError] = useState<string | undefined>();
  const [deliveryMethodError, setDeliveryMethodError] = useState<string | undefined>();

  useEffect(() => {
    if (!hasDeliveryOfferings) {
      setDeliveryMethodError(t.OEB7(deliveryMethodMissingErrMsg));
    }
  }, [hasDeliveryOfferings]);

  const validate = useCallback((): boolean => {
    let isValid = true;
    if (!hasDeliveryAddress) {
      setAddressError(t.XASK('Address information is missing. Select or add address information.'));
      isValid = false;
    }
    if (!hasDeliveryOfferings || !hasSelectedDeliveryMethod) {
      setDeliveryMethodError(t.OEB7(deliveryMethodMissingErrMsg));
      isValid = false;
    }
    return isValid;
  }, [hasDeliveryAddress, hasDeliveryOfferings, hasSelectedDeliveryMethod]);
  const clearAddressError = () => setAddressError(undefined);
  const clearDeliveryMethodError = () => setDeliveryMethodError(undefined);

  return { addressError, deliveryMethodError, clearAddressError, clearDeliveryMethodError, validate };
};
